import * as types from './mutation-types';

export default {
  [types.SET_UNIT_OF_MEASURE_COLLECTION](state, payload) {
    state.unitOfMeasureCollection = payload;
  },
};
